import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';

import { preactMarkup } from 'common/helper/preact/markup';
import { MessageViewStore } from 'common/module/message/view-store';

export function MessageViewStoreFactory(): MessageViewStore {
  // unit test is somehow getting MessageViewStore as undefined
  return MessageViewStore ? new MessageViewStore(EventEmitterFactory(), preactMarkup) : null;
}
